// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__3seGW","fixed":"PageHeader_fixed__3rp6u"};